import { ExternalLink } from "lucide-react"
import { ROBIN_DASHBOARD_URL } from "~/api/robin"
import robinWordmark from "~/images/integrations/robin-wordmark"

// Shown in the My Roster header once Robin has confirmed the connection: a
// "sync is live" indicator + a link out to the Robin dashboard.
export const RobinConnectedStatus = () => {
  return (
    <>
      <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-greenLight/50 text-greenDark text-sm font-medium whitespace-nowrap">
        <span
          className="w-1.5 h-1.5 rounded-full bg-greenDark"
          aria-hidden="true"
        />
        Sync is live with Robin AI
      </span>
      <a
        href={ROBIN_DASHBOARD_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 bg-white text-gray90 border border-gray30 hover:bg-gray20 rounded h-10 px-[24px] py-2 gap-2"
      >
        Open <img {...robinWordmark} alt="Robin" className="h-4 w-auto" />
        <ExternalLink className="w-4 h-4" />
      </a>
    </>
  )
}
